import { safetyRolesList } from './safetyRoles'

export const employmentTypeSeed = [
  'Dipendente',
  'Amministratore',
  'Dirigente',
  'Collaboratore',
  'Altro',
]

export const contractTypeSeed = [
  'Determinato',
  'Indeterminato',
  'Part-time',
  'Collaborazione',
  'Stage',
  'Altro',
]

export const mansioneSeed = [
  'Operaio',
  'Impiegato',
  'Tecnico',
  'Magazziniere',
  'Amministrativa',
]

export const repartoSeed = [
  'Produzione',
  'Amministrazione',
  'Logistica',
  'Commerciale',
  'Manutenzione',
  'Qualità',
  'Magazzino',
  'Ufficio tecnico',
]

export const ruoloSeed = safetyRolesList.map((r) => r.label)

export const courseNameOptions = [
  'Pregresso',
  'Sicurezza generale',
  'Primo soccorso',
  'Antincendio rischio medio',
  'Antincendio rischio basso',
  'Preposto',
  'RLS',
  'Lavori in quota',
  'HACCP',
]
